import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { MaintenanceService } from '../../../services/maintenanceService';


@Component({
    selector: 'app-field-management-table',
    templateUrl: './field-management-table.component.html',
    styleUrl: './field-management-table.component.css',
    standalone: false
})
export class FieldManagementTableComponent implements OnChanges, AfterViewInit, OnInit {


  @ViewChild('reorderTable') reorderTable: MatTable<any>;
  @Input() type: string;
  @Input() tableData: Array<any> = [];
  categories: any = [];
  @Input() columns: Array<any> = [];
  @Input() calc_columns: Array<any> = [];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) empTbSort: MatSort;
  @Output() getReorderedArr = new EventEmitter();

  dataSource: any = new MatTableDataSource([]);
  displayedColumns: Array<any> = [];
  previousIndex = null;
  currentIndexData: any;
  currentColumns: any = [];
  @ViewChild('editFieldPopUp', { static: false }) editFieldPopUp;
  @Input() admin: boolean;
  @Input() systemAdmin: boolean;
  @Input() isUpdated: boolean = false;
  @Input() isEdit: boolean = false;
  @Input() initiativeId: any;
  @Input() clearFormFields: boolean = true;
  showLoader: boolean = false;
  @Output() updateFieldData = new EventEmitter();
  @Input() editRolesOptions = [];
  @Input() fieldDataArr;
  isVisibleFieldDisabled: boolean = false;

  constructor(private toasterService: ToastrService, private maintenanService: MaintenanceService) {

  }

  ngOnInit(): void {
    this.initializeTable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isUpdated && changes.isUpdated.currentValue) {
      this.initializeTable();
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  initializeTable() {
    this.displayedColumns = [];
    this.setupTableColumns();
    this.dataSource = new MatTableDataSource(this.tableData);
    if (this.dataSource.filteredData && this.dataSource.filteredData.length > 0) {
      this.getAllCategories(this.dataSource.filteredData);
    }
    this.dataSource.paginator = this.paginator;
  }

  // This function is used to get all the categories and category default state from the table data
  getAllCategories(data) {
    this.categories = [];
    if(data && data.length > 0){
      this.categories = data.reduce((acc, curr) => {
        if (curr.category && !acc.some(cat => cat.categoryName === curr.category)) {
          acc.push({categoryName : curr.category, defaultState : curr.category_default_state});
        }
        return acc;
      }, []);
    }
  }

  setupTableColumns() {
    this.displayedColumns = this.columns.filter(col => col.isTableKey).map(col => col.key);
  }


  dropTable(event: CdkDragDrop<any[]>) {
    const currentIndex = event.currentIndex + (this.paginator.pageIndex * this.paginator.pageSize); //index on which item is dropped
    if (this.dataSource.data[currentIndex].isReorder) { //check if re ordering is enabled for current field
      const prevIndex = this.dataSource.data.findIndex((d) => d === event.item.data); //finding the index from where dragging is started
      let reOrderArrOrderNo = [];
      if (prevIndex > currentIndex) {
        reOrderArrOrderNo = this.dataSource.data.slice(currentIndex, prevIndex + 1).map(val => val.currentOrder);
      } else if (currentIndex > prevIndex) {
        reOrderArrOrderNo = this.dataSource.data.slice(prevIndex, currentIndex + 1).map(val => val.currentOrder);
      } else {
        return false;
      }
      moveItemInArray(this.dataSource.data, prevIndex, currentIndex);

      let count = 0;
      if (prevIndex > currentIndex) {
        for (let i = currentIndex; i <= prevIndex; i++) {
          this.dataSource.data[i]['currentOrder'] = reOrderArrOrderNo[count];
          count++;
        }
      } else {
        count = reOrderArrOrderNo.length - 1;
        for (let i = currentIndex; i >= prevIndex; i--) {
          this.dataSource.data[i]['currentOrder'] = reOrderArrOrderNo[count];
          count--;
        }
      }
      this.dataSource = new MatTableDataSource(this.dataSource.data);
      this.dataSource.paginator = this.paginator;
      this.getUpdatedCoumns();
    } else {
      this.toasterService.error("Re-ordering is not allowed for this field.", '', { positionClass: 'toast-top-center', timeOut: 1000, });
    }

  }

  getUpdatedCoumns() {
    const filteredArr = this.dataSource.data.filter(element => {
      if (element.colorder != element.currentOrder) {
        return element;
      }
    });
    this.getReorderedArr.emit(filteredArr);
  }

  sortData() {
    this.dataSource.sort = this.empTbSort;
  }

  editField(el) {
    this.isEdit = true;
    this.currentIndexData = _.cloneDeep(el);
    if (el.Field_Type == 'Calc_initiative') this.currentColumns = this.calc_columns;
    else this.currentColumns = this.columns;
    if (el.Modify_UI == 'No' && !this.systemAdmin && this.admin) {
      this.isVisibleFieldDisabled = true;
    } else {
      this.isVisibleFieldDisabled = false;
    }
    this.editFieldPopUp.show();
  }

  closemodal() {
    this.isEdit = false;
    this.currentIndexData = null;
  }

  submitEnableField(payloadData) {
    const obj = {
      type: payloadData.Type,
      message: ''
    }
    this.showLoader = true;
    delete payloadData.Type;
    this.maintenanService.updateFieldForInitiatives(payloadData).subscribe((res) => {
      if (res) {
        this.toasterService.success(res.message, '', { positionClass: 'toast-top-center', timeOut: 2000, });
        obj.message = res.message;
        this.updateFieldData.emit(obj);
        this.editFieldPopUp.hide();
        this.closemodal();
        this.showLoader = false;
      }
    }, () => {
      this.showLoader = false;
      this.toasterService.error("Something went wrong, Please try again later.", '', { positionClass: 'toast-top-center', timeOut: 1000, })
    });


  }
}
